export default "__VITE_ASSET__BHbyG0zi__"